import type { ReactNode } from 'react';
import styles from './PaymentResultLayout.module.css';

export interface PaymentResultLayoutProps {
	header: ReactNode;
	content: ReactNode;
	footer: ReactNode;
	tone?: 'success' | 'error';
}

export const PaymentResultLayout = ({
	header,
	content,
	footer,
	tone = 'success',
}: PaymentResultLayoutProps) => {
	return (
		<div className={`${styles.page} ${styles[`${tone}Bg`]}`}>
			<div className={styles.card}>
				<div className={styles.header}>{header}</div>
				<div className={styles.content}>{content}</div>
				<div className={styles.footer}>{footer}</div>
			</div>
		</div>
	);
};
